import { REVIEWS } from "../data/reviews";

/**
 * Slow editorial marquee.  Duplicated track for a seamless loop.
 * Pulls the strongest raves + 5-star quotes from the archive.
 */
export default function QuoteMarquee() {
  const picks = REVIEWS.filter((r) => r.positivity === "Rave").sort(
    (a, b) => (b.rating || 0) - (a.rating || 0),
  );
  const list = picks.slice(0, 10).map((r) => `“${r.quote}” — ${r.outlet}`);

  return (
    <section
      data-testid="home-marquee"
      className="relative bg-[#8b0000] text-white py-10 md:py-14 border-y border-white/10 overflow-hidden"
      aria-label="Press pull-quotes"
    >
      <div className="marquee">
        {[0, 1].map((k) => (
          <div key={k} className="marquee-track" aria-hidden={k === 1}>
            {list.map((q, i) => (
              <div
                key={`${k}-${i}`}
                className="flex items-center gap-16 whitespace-nowrap"
              >
                <span className="font-display text-3xl md:text-5xl italic leading-none">
                  {q}
                </span>
                <span className="text-white/60 text-2xl md:text-4xl">✦</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
